export const COLORS = {
  green: '#64bc46',
  yellow: '#ffde16',
  red: '#ed1c24',
  white: '#f9f8f8',
  black: '#171717',
  blue: '#197ec1',
  lightBlue: '#5ec2ec',
}